import { api } from "./api";

const visualsService = {

  async getRiskGraphTimeline() {
    try {
      const response = await api.get('/graph');
      return response?.data;
    } catch (error) {
      console.error("Failed to fetch timeline:", error);
      // Custom error message as per your original code
      throw new Error("Failed to fetch timeline");
    }
  },

  async getdepartmentGraphData() {
    try {
      const response = await api.get('/department-risk-score');
      return response?.data;
    } catch (error) {
      console.error("Failed to fetch timeline:", error);
      // Custom error message as per your original code
      throw new Error("Failed to fetch timeline");
    }

  },

  async getdepartmentWiseMfa() {
    try {
      const response = await api.get('/mfa/department/distribution');
      return response?.data;
    } catch (error) {
      console.error("Failed to fetch timeline:", error);
      throw new Error("Failed to fetch timeline");
    }

  },

  async getidentitydistributionData(){
    try {
      const response = await api.get('/identity/distribution');

    //   console.log("graph response",response?.data)
      return response?.data;
    } catch (error) {
      console.error("Failed to fetch timeline:", error);
      // Custom error message as per your original code
      throw new Error("Failed to fetch timeline");
    }

  }


}

export default visualsService;